module.exports = __webpack_public_path__ + "img/service8.b8d6f3b0.png";